export default {
  defailt: {
    title: 'Your journey can become smoother',
    subTitle: 'Faster checkout, booking history, and special promotions just for you',
    alreadyHave: 'Already have an account?',
    logIn: 'Log in',
    joinUs: 'Join us',
    btnSignUp: 'Sign up with your email',
  },
  signIn: {
    title: 'Welcome back!',
    subTitle: 'Log in to your account and continue your journey',
    btnSignIn: 'Sign in',
    serverMessage: 'Email or Password is incorrect.',
    form: {
      fields: {
        email: {
          label: 'Email',
          required: 'Email is required',
        },
        password: {
          label: 'Password',
          required: 'Password is required',
        },
      },
    },
  },
  signUp: {
    title: 'Sign up with email account',
    btnGoogle: 'Continue with Google',
    separateOr: 'OR',
    btnSignUp: 'Sign up with your email',
    serverMessages: {
      exist: 'User email already exists.',
    },
    form: {
      fields: {
        firstName: {
          label: 'First name',
          required: 'First name is required',
        },
        lastName: {
          label: 'Last name',
          required: 'Last name is required',
        },
        phone: {
          label: 'Phone',
        },
        email: {
          label: 'Email',
          required: 'Email is required',
        },
        password: {
          label: 'Password',
          required: 'Password is required',
        },
      },
    },
  },
  footer: {
    text: 'By creating an account you agree to our',
    termsOfUse: ' Terms of use ',
    and: 'and',
    privacyPolicy: 'Privacy policy',
  },
};
